import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const dropdownMenuLabel = tailwindVariants({
  base: 'text-10 pt-2 font-bold uppercase tracking-wide text-grey-10',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'px-2',
      small: 'px-1.5',
    },
  },
});

export type DropdownMenuLabelVariants = VariantProps<typeof dropdownMenuLabel>;

export type DropdownMenuLabelProps = Omit<RadixDropdownMenu.DropdownMenuLabelProps, 'size'> & DropdownMenuLabelVariants;

export const DropdownMenuLabel = memo(({ className, size = 'small', ...restOfProps }: DropdownMenuLabelProps) => {
  return (
    <RadixDropdownMenu.Label
      className={dropdownMenuLabel({ className, size })}
      data-testid="DROPDOWN_MENU_LABEL"
      {...restOfProps}
    />
  );
});

DropdownMenuLabel.displayName = 'DropdownMenuLabel';
